/**
 * Wraps admin route Suspense fallbacks so the Saee preloader sits in the same band as
 * {@link GlobalPreloader} `backofficeMainColumn` (center of the top half of the main column).
 */

import type { ReactNode } from 'react';
import { SaaePreloaderCore } from '@components/SaaePreloaderCore';
import { ADMIN_OUTLET_PRELOADER_OVERLAY_CLASS } from '@lib/adminChrome';

export function AdminOutletSuspenseFallback({ children }: { children: ReactNode }) {
  return (
    <div className="relative isolate">
      <div className={ADMIN_OUTLET_PRELOADER_OVERLAY_CLASS} aria-hidden>
        <SaaePreloaderCore />
      </div>
      {children}
    </div>
  );
}
